import { useContext, useEffect, useState } from "react";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import ApiService from "../../../../services/api";
import "../css/gallery_home.css";
import Lightbox from "react-spring-lightbox";
import { AuthContext } from "../../../../services/auth";

const LightboxHeader = ({
  title,
  currentImageIndex,
  images,
  onClose,
}) => {
  return (
    <Container fluid className="m-0">
    <Row className="px-4 py-3 lightbox-header d-flex align-items-center">
      <Col xs={{ order: 'last',span: 12 }} sm={{ order: 'first',span: 6  }} className="container-title-image">
        <p className="mb-0 text-white  fs-4  h-100">{title}</p>
      </Col>
      <Col>
        <Row className="d-flex align-items-center">
          <Col xs={6} sm={8} className="container-length-image  text-white">
            <h4>
              {currentImageIndex + 1} / {images.length}
            </h4>
          </Col>
          <Col xs={6} sm={4} className="text-end">
            <Button
              variant=""
              onClick={onClose}
              className="lightbox-close-button"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                fill="currentColor"
                className="bi bi-x"
                viewBox="0 0 16 16"
              >
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
              </svg>
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>
    </Container>
  );
};

const LightboxFooter = ({ description }) => {
  return (
    <Container fluid className="m-0">
    <Row className="px-4 py-3 lightbox-footer d-flex align-items-center justify-content-center">
      <Col className="text-center text-white text-lightbox-footer">
        <p className="fs-6 mb-0">{description}</p>
      </Col>
    </Row>
    </Container>
  );
};

const GalleryHome = () => {
  const { isEnglish } = useContext(AuthContext);
  const [category, setCategory] = useState([]);
  const [gallery, setGallery] = useState({});
  const [loading, setLoading] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [images, setImages] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const fetchCategory = async () => {
    const category = await ApiService.getCategories();
    setGallery(await ApiService.getGallery());
    setCategory(category.filter((filter) => filter.type === "gallery"));
    setLoading(false);
  };

  useEffect(() => {
    fetchCategory();
  }, []);

  if (loading) {
    return null;
  }

  const handleImageClick = (content) => {
    setImages(content);
    setCurrentImageIndex(0);
    setIsOpen(true);
  };

  return (
    <Container fluid className="p-0">
      <Container fluid className="padding_custom ps-0 pe-0">
        <h2 className="section-title text-center pt-5">{isEnglish ? "GALLERY" :"GALLERIA"}</h2>
        <div className="border-custom mt-3"></div>
        <Container fluid style={{background: "#d9d9d9"}} className="mt-5">
        <Row className="py-5">
          {category.map((category) => (
            <Col
              key={category.id}
              xl={6}
              lg={12}
              className="p-4 d-flex justify-content-center align-items-center"
            >
              {gallery
                .filter((item) => item.category === category.name)
                .map((gallery) => (
                  <Card
                    className="container_img_gallery"
                    key={gallery.id}
                    onClick={() => handleImageClick(gallery.content)}
                  >
                    <Card.Img
                      variant="top"
                      src={gallery.src}
                      className="container_img_gallery_home"
                    />
                    <Card.Body>
                      <Card.Title className="text_compositions m-0 text-center card-container-text">
                        {isEnglish ? gallery.title_eng : gallery.title }
                      </Card.Title>
                    </Card.Body>
                  </Card>
                ))}
            </Col>
          ))}
        </Row>
        </Container>

        {isOpen && images.length > 0 && (
          <>
          {document.body.classList.add("remove_Scroll")}
          <Lightbox
            className="container_slider_gallery"
            isOpen={isOpen}
            onClose={() => {}}
            images={images.map((img) => ({ src: img.src }))}
            currentIndex={currentImageIndex}
            onPrev={() => {}}
            onNext={() => {}}
            renderHeader={() => (
              <LightboxHeader
              title={isEnglish ? images[currentImageIndex].title_eng : images[currentImageIndex].title}
                currentImageIndex={currentImageIndex}
                images={images}
                onClose={() => {setIsOpen(false) ; document.body.classList.remove("remove_Scroll") ;
                }}
              />
            )}
            renderFooter={() => (
              <LightboxFooter
                images={images}
                currentImageIndex={currentImageIndex}
                description={isEnglish ? images[currentImageIndex].description_eng : images[currentImageIndex].description}
              />
            )}
            renderPrevButton={() => (
              <Button
                variant=""
                onClick={() =>
                  setCurrentImageIndex((prevIndex) =>
                    prevIndex === 0 ? images.length - 1 : prevIndex - 1
                  )
                }
                className="lightbox-prev-button "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100%"
                  height="100%"
                  fill="currentColor"
                  className="bi bi-caret-left-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z" />
                </svg>
              </Button>
            )}
            renderNextButton={() => (
              <Button
                variant=""
                onClick={() =>
                  setCurrentImageIndex((prevIndex) =>
                    prevIndex === images.length - 1 ? 0 : prevIndex + 1
                  )
                }
                className="lightbox-next-button"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100%"
                  height="100%"
                  fill="currentColor"
                  className="bi bi-caret-right-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                </svg>
              </Button>
            )}
            pageTransitionConfig={{
              
              from: { transform: "scale(0.75)", opacity: 0 },
              enter: { transform: "scale(1)", opacity: 1 },
              leave: { transform: "scale(0.75)", opacity: 0 },
              config: { mass: 1, tension: 200, friction: 32 },
            }}
            singleClickToZoom={true}
          /></>
        )}
      </Container>
    </Container>
  );
};

export default GalleryHome;
